import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PaybackSummary {
  system_cost_cents: number | null;
  system_install_date: string | null;
  rate_cents_per_kwh: number;
  first_telemetry_date: string | null;
  total_monitored_days: number;
  verified_savings_cents: number;
  avg_daily_savings_cents: number;
  pre_monitoring_days: number;
  estimated_pre_monitoring_savings_cents: number;
  total_savings_cents: number;
}

export function usePaybackSummary(propertyId: string | undefined) {
  return useQuery({
    queryKey: ['payback-summary', propertyId],
    queryFn: async (): Promise<PaybackSummary | null> => {
      if (!propertyId) return null;

      const { data, error } = await supabase.rpc('get_payback_summary', {
        p_property_id: propertyId,
      });

      if (error) throw error;
      return data as unknown as PaybackSummary;
    },
    enabled: !!propertyId,
    staleTime: 5 * 60 * 1000,
  });
}
